let ENGLISH = "en"
let JAPANESE = "jp"
let TRADITIONAL_CHINESE = "tc"
let SIMPLIFIED_CHINESE = "sc"

const LANGUAGE_ABBR = {
    ENGLISH: ENGLISH,
    JAPANESE: JAPANESE,
    TRADITIONAL_CHINESE: TRADITIONAL_CHINESE,
    SIMPLIFIED_CHINESE: SIMPLIFIED_CHINESE,
}

// 1: Wazaren
// 2: Wotageishi
// 3: Organization
// 4: Movement
// 5: Video

export const explainedTerms = [
    {
        category: 5,
        title: {
            [ENGLISH]: "垢始動",
            [JAPANESE]: "垢始動",
            [TRADITIONAL_CHINESE]: "垢始動",
            [SIMPLIFIED_CHINESE]: "垢始動",
        },
        description: {
            [ENGLISH]: "打ち師としての自分のアカウントで動画を初めてアップロードするときに使う言葉。",
            [JAPANESE]: "打ち師としての自分のアカウントで動画を初めてアップロードするときに使う言葉。",
            [TRADITIONAL_CHINESE]: "打ち師としての自分のアカウントで動画を初めてアップロードするときに使う言葉。",
            [SIMPLIFIED_CHINESE]: "打ち師としての自分のアカウントで動画を初めてアップロードするときに使う言葉。",
        }
    },
    {
        category: 5,
        title: {
            [ENGLISH]: "合わせ技",
            [JAPANESE]: "合わせ技",
            [TRADITIONAL_CHINESE]: "合わせ技",
            [SIMPLIFIED_CHINESE]: "合わせ技",
        },
        description: {
            [ENGLISH]: "2つの技を合わせたムーブのこと。複数人で合わせる技のこと。",
            [JAPANESE]: "2つの技を合わせたムーブのこと。複数人で合わせる技のこと。",
            [TRADITIONAL_CHINESE]: "2つの技を合わせたムーブのこと。複数人で合わせる技のこと。",
            [SIMPLIFIED_CHINESE]: "2つの技を合わせたムーブのこと。複数人で合わせる技のこと。",
        }
    },
    {
        category: 5,
        title: {
            [ENGLISH]: "打ち納め",
            [JAPANESE]: "打ち納め",
            [TRADITIONAL_CHINESE]: "打ち納め",
            [SIMPLIFIED_CHINESE]: "打ち納め",
        },
        description: {
            [ENGLISH]: "年終わりにヲタ芸を打つこと",
            [JAPANESE]: "年終わりにヲタ芸を打つこと",
            [TRADITIONAL_CHINESE]: "年終わりにヲタ芸を打つこと",
            [SIMPLIFIED_CHINESE]: "年終わりにヲタ芸を打つこと",
        }
    },
    {
        category: 2,
        title: {
            [ENGLISH]: "打ち師",
            [JAPANESE]: "打ち師",
            [TRADITIONAL_CHINESE]: "打ち師",
            [SIMPLIFIED_CHINESE]: "打ち師",
        },
        description: {
            [ENGLISH]: "ヲタ芸を打っている人",
            [JAPANESE]: "ヲタ芸を打っている人",
            [TRADITIONAL_CHINESE]: "ヲタ芸を打っている人",
            [SIMPLIFIED_CHINESE]: "ヲタ芸を打っている人",
        }
    },
    {
        category: 5,
        title: {
            [ENGLISH]: "最終章",
            [JAPANESE]: "最終章",
            [TRADITIONAL_CHINESE]: "最終章",
            [SIMPLIFIED_CHINESE]: "最終章",
        },
        description: {
            [ENGLISH]: "ヲタ芸界隈での意味は｢自分のアカウントでアップロードする最後の動画｣と｢ヲタ芸引退or休止｣のどちらかで使われる。前者の場合は必ずしも引退するという訳ではない",
            [JAPANESE]: "ヲタ芸界隈での意味は｢自分のアカウントでアップロードする最後の動画｣と｢ヲタ芸引退or休止｣のどちらかで使われる。前者の場合は必ずしも引退するという訳ではない",
            [TRADITIONAL_CHINESE]: "ヲタ芸界隈での意味は｢自分のアカウントでアップロードする最後の動画｣と｢ヲタ芸引退or休止｣のどちらかで使われる。前者の場合は必ずしも引退するという訳ではない",
            [SIMPLIFIED_CHINESE]: "ヲタ芸界隈での意味は｢自分のアカウントでアップロードする最後の動画｣と｢ヲタ芸引退or休止｣のどちらかで使われる。前者の場合は必ずしも引退するという訳ではない",
        }
    },
    {
        category: 5,
        title: {
            [ENGLISH]: "時空越え",
            [JAPANESE]: "時空越え",
            [TRADITIONAL_CHINESE]: "時空越え",
            [SIMPLIFIED_CHINESE]: "時空越え",
        },
        description: {
            [ENGLISH]: "各自撮影した動画を合わせて１つの動画にすること。",
            [JAPANESE]: "各自撮影した動画を合わせて１つの動画にすること。",
            [TRADITIONAL_CHINESE]: "各自撮影した動画を合わせて１つの動画にすること。",
            [SIMPLIFIED_CHINESE]: "各自撮影した動画を合わせて１つの動画にすること。",
        }
    },
    {
        category: 1,
        title: {
            [ENGLISH]: "中国技",
            [JAPANESE]: "中国技",
            [TRADITIONAL_CHINESE]: "中国技",
            [SIMPLIFIED_CHINESE]: "中国技",
        },
        description: {
            [ENGLISH]: "中国勢のヲタ芸打ち師が作った技のこと。〇〇技(地名などが入る)に関しても同じ",
            [JAPANESE]: "中国勢のヲタ芸打ち師が作った技のこと。〇〇技(地名などが入る)に関しても同じ",
            [TRADITIONAL_CHINESE]: "中国勢のヲタ芸打ち師が作った技のこと。〇〇技(地名などが入る)に関しても同じ",
            [SIMPLIFIED_CHINESE]: "中国勢のヲタ芸打ち師が作った技のこと。〇〇技(地名などが入る)に関しても同じ",
        }
    },
    {
        category: 5,
        title: {
            [ENGLISH]: "TP",
            [JAPANESE]: "TP",
            [TRADITIONAL_CHINESE]: "TP",
            [SIMPLIFIED_CHINESE]: "TP",
        },
        description: {
            [ENGLISH]: "突破の略。Youtubeアカウント登録者が目標の人数越えたときに使う(例:100TP)",
            [JAPANESE]: "突破の略。Youtubeアカウント登録者が目標の人数越えたときに使う(例:100TP)",
            [TRADITIONAL_CHINESE]: "突破の略。Youtubeアカウント登録者が目標の人数越えたときに使う(例:100TP)",
            [SIMPLIFIED_CHINESE]: "突破の略。Youtubeアカウント登録者が目標の人数越えたときに使う(例:100TP)",
        }
    },
]